'use es6';

import { createTracker } from 'usage-tracker';
import { getTrackPayload, TRACK_EVENT } from 'usage-tracker-redux';
import events from 'content-detail-ui/events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const trackerInstance = createTracker({
  events
});
setPrimaryTracker(trackerInstance, REPORTING_TRACKER);
const DEFAULTS = {
  events,
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: err => {
    throw err;
  },
  properties: {
    namespace: 'content-detail-ui'
  }
};
export const usageTracker = createTracker(DEFAULTS);
export const usageTrackerAsBeacon = createTracker(Object.assign({}, DEFAULTS));
export const getUsageTrackerMeta = (event, eventProperties = {}) => ({
  [TRACK_EVENT]: getTrackPayload(event, eventProperties)
});